/**
 * FindingsEmptyState -- Shown when an audit has no confirmed findings
 */

export function FindingsEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center space-y-2">
      <p className="text-muted-foreground">No findings yet.</p>
      <p className="text-sm text-muted-foreground">
        Generate findings from checklist items or add them manually in the
        checklist.
      </p>
    </div>
  );
}
